import React, { useState } from 'react';
import { Link } from "react-router-dom";
import Navbar from "../sections/Navbar";
import Footer from "../sections/Footer";
import { Check } from "lucide-react"; // A clean, modern checkmark icon

import SubscriptionFormModal from '../components/SubscriptionFormModal';

// Import your images
import subHeroImage from "../assets/images/sub-hero.jpeg";
import lifestyleImage from "../assets/images/sub-lifestyle.jpg";
import inStoreImage from "../assets/images/cafe-space.png";
import brandLogo from "../assets/logo/logo-white.png";
import CtaSection from "../sections/CtaSection";
import curatedImage from '../assets/images/sub-curated.jpg';
import flexibleImage from '../assets/images/sub-flexible.jpg';
// --- Static data for the subscription plans ---


const plans = [
  {
    id: 'GRMS-ABC123',
    name: "Home Brewer",
    price: "500 DH",
    monthlyPrice: 500,
    features: [
      "10 Drinks a month",
      "2 Coffee Beans (250g)",
      "30% Off on 1 Store item",
    ],
  },
  {
    name: "Essential",
    price: "800Dh/month",
    threeMonthPrice: 1800,
    monthlyPrice: 800,
    billing: "1800Dh/3 months",
    isBestValue: true,
    features: [
      "5 Drinks a week",
      "4 Breakfasts",
      "20% of discount all menu",
      "15% of discount of shop",
      "Grams premium pottery mug",
    ],
  },
  {
    name: "Daily Ritual",
    price: "1600Dh/month",
    monthlyPrice: 1600,
    threeMonthPrice: 4200,
    billing: "4200Dh/3 months",
    features: [
      "30 Drinks a month",
      "3 Breakfasts a week",
      "20% of discount all menu",
      "15% of discount of shop",
      "Grams premium pottery mug GIFTED",
      "Bamboo coffee saucer",
    ],
  },
];
const SubscriptionScreen = () => {
  // --- NEW: State to manage the modal ---
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePlanClick = (plan) => {
    setSelectedPlan(plan);
    setIsModalOpen(true);
  };

  return (
    <>
      <Navbar />
      <div className="subscription-page">
        {/* --- 1. HERO SECTION --- */}
        <section
          className="sub-hero"
          style={{ backgroundImage: `url(${subHeroImage})` }}
        >
          <div className="sub-hero-overlay"></div>
          <div className="sub-hero-content">
            <h1>Elevate Your Daily Ritual.</h1>
            <p>
              Join the Grams Subscription family and unlock exclusive perks,
              curated coffee experiences, and unparalleled value. More than a
              subscription—it's a lifestyle.
            </p>
          </div>
          <div className="hero-actions">
            {/* The first button can scroll down to the plans, or go to a different page */}
            <a href="/store" className="hero-action-btn">
              <span>Discover Shop</span>
            </a>
            {/* The second button can link to a future "Gifts" page */}
            <Link to="/menu" className="hero-action-btn">
              <span>Browse Menu</span>
            </Link>
          </div>
        </section>

        <section className="sub-info-section">
          <div className="info-image-container">
            <img src={curatedImage} alt="Curated selection of coffee beans" />
          </div>
          <div className="info-text-container">
            <h2>What Makes Our Subscriptions Special?</h2>
            <p>Our subscriptions are more than just a delivery service; they are a curated journey into the world of specialty coffee. Each month, our experts select premium, single-origin beans and exclusive blends, ensuring you experience a diverse range of flavors that you won't find anywhere else. It's a commitment to discovery and uncompromising quality, delivered to your door.</p>
          </div>
        </section>

        {/* --- NEW SECTION 2: Image on the Right (Reversed) --- */}
        <section className="sub-info-section reverse">
          <div className="info-image-container">
            <img src={flexibleImage} alt="Person enjoying a cup of coffee at home" />
          </div>
          <div className="info-text-container">
            <h2>Designed For Your Lifestyle?</h2>
            <p>We understand that your coffee ritual is personal. That's why our plans are designed with flexibility in mind. Whether you're a home brewer exploring new methods or a daily commuter needing your caffeine fix, there's a plan that fits your routine. Easily manage, pause, or adjust your subscription from your account—no commitments, just great coffee on your terms.</p>
          </div>
        </section>

       

        {/* --- 3. VISUAL BREAK #1 --- */}
       <section className="visual-break">
          <img src={lifestyleImage} alt="A cozy coffee lifestyle scene" />
          <div className="visual-break-overlay"></div>
          <div className="visual-break-content right">
            <h3>Curated for Your Home</h3>
            <p>Experience the best of specialty coffee without leaving your house. Each delivery is a new discovery, selected by our experts.</p>
          </div>
        </section>

       {/* --- 2. PLAN COMPARISON SECTION --- */}
        <section className="sub-plans-container">
            <h2>What We Provide</h2>
          <div className="plans-grid">
            {plans.map(plan => (
              // --- MODIFIED: The card is now a clickable div ---
              <div 
                key={plan.name} 
                className={`plan-card ${plan.isBestValue ? 'best-value' : ''}`}
                onClick={() => handlePlanClick(plan)}
              >
                {plan.isBestValue && <div className="value-badge">BEST VALUE</div>}
                <div className="plan-header">
                  <h3>{plan.name}</h3>
                  <p className="price">{plan.price}</p>
                  {plan.billing && <p className="billing">{plan.billing}</p>}
                </div>
                <ul className="features-list">
                  {plan.features.map((feature, index) => (
                    <li key={index}><Check size={16} /> <span>{feature}</span></li>
                  ))}
                </ul>
                {/* --- NEW: A visual cue for the button --- */}
                <div className="choose-plan-btn">Choose Plan</div>
              </div>
            ))}
          </div>
        </section>
        

        {/* --- 4. FAQ SECTION --- */}
        <section className="sub-faq-container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-item">
            <h4>How do I redeem my drinks and breakfasts?</h4>
            <p>
              Your subscription is linked to your digital account via our mobile
              app. Simply present your app at the counter to redeem your perks
              instantly.
            </p>
          </div>
          <div className="faq-item">
            <h4>Do the discounts apply to all items?</h4>
            <p>
              The discounts apply to all regularly priced menu and shop items.
              They cannot be combined with other special promotions or offers.
            </p>
          </div>
        </section>

        {/* --- 5. VISUAL BREAK #2 --- */}
        

        {/* --- 6. FINAL CTA --- */}
        <section className="sub-final-cta">
         
          <h2>Ready to Join?</h2>
          <p>
            Our subscription plans are available for in-store signup. Visit us
            at our Agadir location to activate your plan and start enjoying your
            perks today.
          </p>
          <div className="footer-note">
            MORE DETAILS AVAILABLE AT THE COUNTER
          </div>
        </section>
      </div>
       <SubscriptionFormModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        plan={selectedPlan}
      />
      <CtaSection />
      <Footer />
    </>
  );
};
export default SubscriptionScreen;
